import L from 'leaflet';

// Point-in-area geometry, used by listvy's street search (findAreaLayerAt) to find a street's RegSO area.
// (Phones no longer get a tap/hold "hover" look on tiles — the Färger toggle already shows an area's colours.)

const ringContains = (ring, lat, lng) => {
    let inside = false;
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i, i += 1) {
        const a = ring[i];
        const b = ring[j];
        if ((a.lat > lat) !== (b.lat > lat) && lng < ((b.lng - a.lng) * (lat - a.lat)) / (b.lat - a.lat) + a.lng) {
            inside = !inside;
        }
    }
    return inside;
};

const polygonContains = (rings, lat, lng) => (
    ringContains(rings[0], lat, lng) && !rings.slice(1).some((hole) => ringContains(hole, lat, lng))
);

const layerContains = (layer, latlng) => {
    const latlngs = layer.getLatLngs?.();
    if (!latlngs?.length) return false;
    const { lat, lng } = latlng;
    if (L.LineUtil.isFlat(latlngs)) return ringContains(latlngs, lat, lng);
    if (L.LineUtil.isFlat(latlngs[0])) return polygonContains(latlngs, lat, lng);
    return latlngs.some((polygon) => polygonContains(polygon, lat, lng));
};

// GeoJSON rings are [lng, lat] pairs.
const coordRingContains = (ring, lat, lng) => {
    let inside = false;
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i, i += 1) {
        const [aLng, aLat] = ring[i];
        const [bLng, bLat] = ring[j];
        if ((aLat > lat) !== (bLat > lat) && lng < ((bLng - aLng) * (lat - aLat)) / (bLat - aLat) + aLng) {
            inside = !inside;
        }
    }
    return inside;
};

const coordPolygonContains = (rings, lat, lng) => (
    coordRingContains(rings[0], lat, lng) && !rings.slice(1).some((hole) => coordRingContains(hole, lat, lng))
);

// The area layer at a point, tested against the full geometry (not the simplified outline drawn when zoomed
// out). Used by listvy's street search to find a street's area.
export const findAreaLayerAt = (group, lat, lng) => {
    if (!group) return null;
    const latlng = L.latLng(lat, lng);
    let hit = null;
    group.eachLayer((layer) => {
        if (hit || !layer.feature || !layer.getBounds?.().contains(latlng)) return;
        const geometry = layer.feature.geometry;
        const inside = geometry?.type === 'Polygon'
            ? coordPolygonContains(geometry.coordinates, lat, lng)
            : geometry?.type === 'MultiPolygon'
                ? geometry.coordinates.some((polygon) => coordPolygonContains(polygon, lat, lng))
                : layerContains(layer, latlng);
        if (inside) hit = layer;
    });
    return hit;
};
